export default __webpack_public_path__ + "static/media/insta.456119eb.svg";